export default __webpack_public_path__ + "static/media/kitchen4-afterA-1440w.5b07dc0e.avif";